module.exports = __webpack_public_path__ + "static/media/location.ec1cb13d.svg";